// extracted by mini-css-extract-plugin
export var active = "TextAndCarouselModule-module--active--75c16";
export var activeImage = "TextAndCarouselModule-module--activeImage--eb09f";
export var carouselBarContainer = "TextAndCarouselModule-module--carouselBarContainer--cef1d";
export var carouselBarsContainer = "TextAndCarouselModule-module--carouselBarsContainer--92b6b";
export var carouselContainer = "TextAndCarouselModule-module--carouselContainer--d274b";
export var content = "TextAndCarouselModule-module--content--07803";
export var contentContainer = "TextAndCarouselModule-module--contentContainer--708e1";
export var contentWrapper = "TextAndCarouselModule-module--contentWrapper--c20a1";
export var fadeIn = "TextAndCarouselModule-module--fadeIn--eb311";
export var fadeOut = "TextAndCarouselModule-module--fadeOut--93f4a";
export var image = "TextAndCarouselModule-module--image--34557";
export var imageContainer = "TextAndCarouselModule-module--imageContainer--fe38d";
export var leftArrow = "TextAndCarouselModule-module--leftArrow--620d8";
export var mediaContainer = "TextAndCarouselModule-module--mediaContainer--af167";
export var nextImage = "TextAndCarouselModule-module--nextImage--fd49b";
export var rightArrow = "TextAndCarouselModule-module--rightArrow--46d5c";
export var text = "TextAndCarouselModule-module--text--6dc1b";
export var textContainer = "TextAndCarouselModule-module--textContainer--2050c";
export var title = "TextAndCarouselModule-module--title--ccf86";
export var visuallyHidden = "TextAndCarouselModule-module--visuallyHidden--37792";